export const stripeConfig = {
    publishableKey: window["env"]["stripeKey"] || ""
}
